import {definePreset} from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const muwaridPrimary = {
  50: 'color-mix(in srgb, var(--color-primary, #0D6BB1) 8%, white)',
  100: 'color-mix(in srgb, var(--color-primary, #0D6BB1) 16%, white)',
  200: 'color-mix(in srgb, var(--color-primary, #0D6BB1) 32%, white)',
  300: 'color-mix(in srgb, var(--color-primary, #0D6BB1) 48%, white)',
  400: 'color-mix(in srgb, var(--color-primary, #0D6BB1) 64%, white)',
  500: 'var(--color-primary, #0D6BB1)',
  600: 'color-mix(in srgb, var(--color-primary, #0D6BB1) 85%, black)',
  700: 'color-mix(in srgb, var(--color-primary, #0D6BB1) 70%, black)',
  800: 'color-mix(in srgb, var(--color-primary, #0D6BB1) 55%, black)',
  900: 'color-mix(in srgb, var(--color-primary, #0D6BB1) 40%, black)',
  950: 'color-mix(in srgb, var(--color-primary, #0D6BB1) 25%, black)',
};

const muwaridSecondary = {
  50: 'color-mix(in srgb, var(--brand-secondary, #198F79) 8%, white)',
  100: 'color-mix(in srgb, var(--brand-secondary, #198F79) 16%, white)',
  200: 'color-mix(in srgb, var(--brand-secondary, #198F79) 32%, white)',
  300: 'color-mix(in srgb, var(--brand-secondary, #198F79) 48%, white)',
  400: 'color-mix(in srgb, var(--brand-secondary, #198F79) 64%, white)',
  500: 'var(--brand-secondary, #198F79)',
  600: 'color-mix(in srgb, var(--brand-secondary, #198F79) 85%, black)',
  700: 'color-mix(in srgb, var(--brand-secondary, #198F79) 70%, black)',
  800: 'color-mix(in srgb, var(--brand-secondary, #198F79) 55%, black)',
  900: 'color-mix(in srgb, var(--brand-secondary, #198F79) 40%, black)',
  950: 'color-mix(in srgb, var(--brand-secondary, #198F79) 25%, black)',
};

export const MuwaridPreset = definePreset(Aura, {
  semantic: {
    primary: muwaridPrimary,
    secondary: muwaridSecondary,
  },
  components: {
    tooltip: {
      root: {
        maxWidth: '20rem',
        padding: '0.5rem 0.75rem',
        borderRadius: '8px',
      },
    },
  },
});
